export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00737.78ce0242.png";